import { runInAction } from 'mobx'

import { http } from 'utils'
import { config } from 'config'

import BaseStore from './BaseStore'
import { DEFAULT_COUNTRY_LIST } from 'config/defaultCountry'

let state

export class Country extends BaseStore {
  constructor() {
    super()
    this.observable({
      list: [],
      defaultCountryIndex: 0,
    })
    state = this
  }

  assignFlagIcon(
    flagCode // Example: U+1F1E6 U+1F1EB
  ) {
    const unicodeArray = flagCode
      .split(' ')
      .map((code) => code.replace('U+', ''))
    const charString = unicodeArray
      .map((code) => String.fromCodePoint(parseInt(code, 16)))
      .join('')

    return charString
  }

  async getCountry(def = {}) {
    try {
      const current = this.toJS()
      if (current.list.length > 0) return current

      const url = `${config.api}/notification-center/country`
      const res = await http.get(url)
      return this.setupCountryList(res.body?.data, def)
    } catch (error) {
      return this.setupCountryList(DEFAULT_COUNTRY_LIST, def)
    }
  }

  setupCountryList(tempCountryList, def = {}) {
    const list = tempCountryList || []

    const index = list.findIndex((country) => {
      return country.countryName === def.countryName
    })

    const defaultCountryIndex = index < 0 ? 0 : index

    const countryList = list.map((it) => {
      it.flagIcon = this.assignFlagIcon(it.flag)
      return it
    })

    runInAction(() => {
      state.list = countryList
      state.defaultCountryIndex = index < 0 ? 0 : index
    })

    return { list, defaultCountryIndex }
  }
}

export default new Country()
